import { HeadingPages } from '../../../components/HeadingPages'
import { Box, Container, FormControl, FormLabel, Input, Button, VStack, useToast, FormErrorMessage } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { useMutation } from 'react-query'
import axios from 'axios'
import { useUser } from '../../../hooks/useUser'

export function EnviarPedidoDeCompra() {
  const toast = useToast()
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm()

  const { nome_usuario } = useUser()

  const enviarPedidoMutation = useMutation({
    mutationFn: (data) => {
      return axios.post('https://api.innovationbrindes.com.br/api/site/v2/fiscal/envia-pedido-compra', {
        numero_nota: data.numeroPedido,
        nome_usuario: nome_usuario,
      })
    },
    onSuccess: () => {
      toast({
        title: 'Sucesso!',
        description: 'Pedido de compra enviado com sucesso.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })
      reset()
    },
    onError: () => {
      toast({
        title: 'Erro',
        description: 'Não foi possível enviar o pedido de compra.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    },
  })

  const onSubmit = (data) => {
    enviarPedidoMutation.mutate(data)
  }

  return (
    <Box>
      <HeadingPages name="Enviar Pedido de Compra" />

      <Container maxW="container.md" py={8}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <VStack spacing={6}>
            <FormControl isInvalid={errors.numeroPedido}>
              <FormLabel>Número do Pedido</FormLabel>
              <Input
                {...register('numeroPedido', {
                  required: 'Este campo é obrigatório',
                  pattern: {
                    value: /^\d+$/,
                    message: 'Digite apenas números',
                  },
                })}
                placeholder="Digite o número do pedido"
                bg="white"
                borderColor="gray.300"
              />
              <FormErrorMessage>{errors.numeroPedido && errors.numeroPedido.message}</FormErrorMessage>
            </FormControl>

            <Button type="submit" colorScheme="blue" isLoading={enviarPedidoMutation.isLoading} loadingText="Enviando..." width="full">
              Enviar Pedido
            </Button>
          </VStack>
        </form>
      </Container>
    </Box>
  )
}
